<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.75 9.83333V14.8333C13.75 15.2754 13.5744 15.6993 13.2618 16.0118C12.9493 16.3244 12.5254 16.5 12.0833 16.5H2.91667C2.47464 16.5 2.05072 16.3244 1.73816 16.0118C1.42559 15.6993 1.25 15.2754 1.25 14.8333V5.66667C1.25 5.22464 1.42559 4.80072 1.73816 4.48816C2.05072 4.17559 2.47464 4 2.91667 4H7.91667M11.25 1.5H16.25M16.25 1.5V6.5M16.25 1.5L7.08333 10.6667"
      :stroke="color"
      :stroke-width="strokeWidth"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  width: {
    type: [String, Number],
    default: "18",
  },
  height: {
    type: [String, Number],
    default: "18",
  },
  color: {
    type: String,
    default: "#003D6A",
  },
  strokeWidth: {
    type: [String, Number],
    default: "2",
  },
});
</script>
